import SenderReceiverDataTypeListItem from '../components/SenderReceiverDataTypeListItem'

export default class IntegrationItem extends SenderReceiverDataTypeListItem {}
